import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  IcCalendar, IcCalendarCheck, IcPlus, IcPdf, IcAt, IcExcel,
  IcSync, IcCheckCircle, IcPauseCircle, IcEdit, IcDollar,
  IcSave, IcChartLine,
} from "../../Icons";
import axios from "axios";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  FormGroup,
} from "reactstrap";
import { TableHeader, Pagination, Search } from "../../DataTable";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../layout/Header/Header";
import Baja from "../Baja";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../pdfUtils";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import useFullPageLoader from "../../hooks/useFullPageLoader";

// Meses para "Mes de aumento" (se guarda el nombre; "" = sin definir)
const MESES = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];
const MES_ACTUAL = MESES[new Date().getMonth()];

// Un color por mes, sin repetir: fondo claro, borde medio y texto oscuro del
// mismo tono (el nombre del mes siempre va escrito, el color solo ayuda a
// ubicarlo de un vistazo).
const COLOR_MES = {
  Enero:      { bg: "#dbeafe", borde: "#93c5fd", txt: "#1e40af" }, // azul
  Febrero:    { bg: "#e0e7ff", borde: "#a5b4fc", txt: "#3730a3" }, // índigo
  Marzo:      { bg: "#ede9fe", borde: "#c4b5fd", txt: "#5b21b6" }, // violeta
  Abril:      { bg: "#fae8ff", borde: "#f0abfc", txt: "#86198f" }, // fucsia
  Mayo:       { bg: "#fce7f3", borde: "#f9a8d4", txt: "#9d174d" }, // rosa
  Junio:      { bg: "#fee2e2", borde: "#fca5a5", txt: "#991b1b" }, // rojo
  Julio:      { bg: "#ffedd5", borde: "#fdba74", txt: "#9a3412" }, // naranja
  Agosto:     { bg: "#fef3c7", borde: "#fcd34d", txt: "#92400e" }, // ámbar
  Septiembre: { bg: "#ecfccb", borde: "#bef264", txt: "#3f6212" }, // lima
  Octubre:    { bg: "#dcfce7", borde: "#86efac", txt: "#166534" }, // verde
  Noviembre:  { bg: "#ccfbf1", borde: "#5eead4", txt: "#115e59" }, // turquesa
  Diciembre:  { bg: "#cffafe", borde: "#67e8f9", txt: "#155e75" }, // cian
};

function ListadoMensualidades() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_MENSUALIDADES = process.env.REACT_APP_URL_MENSUALIDADES;
  const URL_CARGOS = process.env.REACT_APP_URL_CARGOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;

  const [mensualidades, setMensualidades] = useState([]);
  const [frecuencia, setFrecuencia] = useState("");
  const [selectedFrecuencia, setSelectedFrecuencia] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("");
  const [selectedCeros, setSelectedCeros] = useState("Si");
  const [selectedMesAumento, setSelectedMesAumento] = useState("");
  const [fecha, setFecha] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [clientes, setClientes] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [modalGenera, setModalGenera] = useState(false);
  const toggleGenera = () => setModalGenera(!modalGenera);
  const [text, setText] = useState(false);
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");
  // const [activo, setActivo] = useState("");

  // const [modal, setModal] = useState(false);
  // const toggle = () => setModal(!modal);
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [modalAumento, setModalAumento] = useState(false);
  const toggleAumento = () => setModalAumento(!modalAumento);
  const [idInfo, setIdInfo] = useState("");
  const [idCargo, setidCargo] = useState();
  const [nuevo_importe, setNuevoImporte] = useState();
  const [fecha_inicio, setFechaInicio] = useState();
  const [fecha_aumento, setFechaAumento] = useState();
  const [ultimo_aumento, setUltimoAumento] = useState();
  const [frecuenciaEdit, setFrecuenciaEdit] = useState();
  const [descripcionEdit, setDescripcionEdit] = useState();
  const [observacionesEdit, setObservacionesEdit] = useState();
  const [mesAumentoEdit, setMesAumentoEdit] = useState("");
  const [importe_anterior, setImporteAnterior] = useState();
  const [importe_actual, setImporteActual] = useState();
  const [selectedCliente, setSelectedCliente] = useState();
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedEmpresaFiltro, setSelectedEmpresaFiltro] = useState("ExceptoSistemify");
  const [selectedClienteName, setSelectedClienteName] = useState();

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [refreshCount,   setRefreshCount]   = useState(0);
  const [modalCreate,    setModalCreate]    = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const todayStr = new Date().toISOString().split("T")[0];
  const [cFechaIni,     setCFechaIni]     = useState(todayStr);
  const [cFrecuencia,   setCFrecuencia]   = useState("Mensual");
  const [cImporteMens,  setCImporteMens]  = useState("");
  const [cDescMens,     setCDescMens]     = useState("");
  const [cObsMens,      setCObsMens]      = useState("");
  const [cMesAumento,   setCMesAumento]   = useState("");
  const [cClienteMens,  setCClienteMens]  = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_MENSUALIDADES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMensualidades = response.data;
             // Array para pagination
             let arrayTabla = allMensualidades
             .sort((a, b) => (a.clientes[0].nombre_comercial > b.clientes[0].nombre_comercial ? 1 : -1))
             .map((a) => {
                 return {
                   _id: a._id,
                   is_active: a.is_active,
                   ultimo_aumento: a.ultimo_aumento,
                   mes_aumento: a.mes_aumento || "",
                   importe_actual: a.importe_actual,
                   frecuencia: a.frecuencia,
                   descripcion: a.descripcion,
                   observaciones: a.observaciones,
                   fecha_inicio: a.fecha_inicio,
                   idCliente: a.clientes[0]._id,
                   cliente: a.clientes[0].nombre_comercial,
                   empresa: a.clientes[0].empresa,
                   contacto: a.clientes[0].contacto,
                 }
             })
             .filter(function (el) {
               return el != null;
             });
   
           let dataFinal = Object.values(arrayTabla);
   
           setMensualidades(allMensualidades);
           setComments(dataFinal);
           //
      })
      .catch((err) => {
      });
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
      });
  }, [refreshCount]); // eslint-disable-line

  function saveMensualidad() {
    if (!cClienteMens || !cFechaIni || !cFrecuencia || !cImporteMens) {
      return Swal.fire({ icon: "warning", title: "Completa todos los campos requeridos" });
    }
    axios.post(URL_MENSUALIDADES, {
      fecha_inicio: cFechaIni, frecuencia: cFrecuencia, descripcion: cDescMens || "NA",
      observaciones: cObsMens || "NA", importe_actual: Number(cImporteMens),
      importe_anterior: 0, ultimo_aumento: cFechaIni, clientes: cClienteMens,
      mes_aumento: cMesAumento,
    }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then(() => {
        setCFechaIni(new Date().toISOString().split("T")[0]);
        setCFrecuencia("Mensual"); setCImporteMens(""); setCDescMens(""); setCObsMens(""); setCClienteMens("");
        setCMesAumento("");
        setModalCreate(false);
        setRefreshCount((p) => p + 1);
        Swal.fire({ icon: "success", title: "Mensualidad creada", timer: 1500, showConfirmButton: false });
      })
      .catch(() => Swal.fire({ icon: "error", title: "Error al guardar" }));
  }

  // PDF
  let totalImporte = 0;

  let tablaImporte = 0;
  let cantidad = 0;
function PDFTabla() {
  let totalImporte = 0;

  const dataPDFLimpia = comments
    .filter((a) => {
      const pasaEmpresa =
        selectedEmpresaFiltro === "" ||
        (selectedEmpresaFiltro === "ExceptoSistemify"
          ? a.empresa !== "Sistemify"
          : a.empresa === selectedEmpresaFiltro);

      const pasaFrecuencia =
        selectedFrecuencia == 0 || a.frecuencia == selectedFrecuencia;

      const pasaActivo = selectedActivo == 0 || a.is_active == selectedActivo;

      const pasaCeros =
        selectedCeros === "No" ||
        (selectedCeros === "Si" && a.importe_actual !== 0);

      const pasaMes =
        !selectedMesAumento ||
        (selectedMesAumento === "SinMes"
          ? !a.mes_aumento
          : a.mes_aumento === selectedMesAumento);

      return pasaEmpresa && pasaFrecuencia && pasaActivo && pasaCeros && pasaMes;
    })
    .map((a) => {
      totalImporte += Number(a.importe_actual) || 0;

      const importe =
        "$" + new Intl.NumberFormat("en-US").format(a.importe_actual);

      return [a.cliente, a.fecha_inicio, a.mes_aumento || "-", a.frecuencia, importe];
    });

  const doc = new jsPDF();
  const startY = pdfHeader(doc, "Listado Mensualidades");

  doc.autoTable({
    ...pdfTableStyles(),
    head: [["Cliente", "Fecha Inicio", "Mes Aumento", "Frecuencia", "Importe"]],
    body: dataPDFLimpia,
    startY,
    foot: [
      [
        "",
        "",
        "",
        "Totales",
        "$" + new Intl.NumberFormat("en-US").format(totalImporte),
      ],
    ],
    showFoot: "lastPage",
  });

  pdfFooter(doc);
  doc.save(`Mensualidades.pdf`);
}


  function generaMensualidades() {
    toggleGenera();
    Swal.fire({
      title: "Estas Seguro?",
      text: "Se generara un cargo a cada cliente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, generar cargo",
    }).then((result) => {
      if (result.value) {
        toggleProgreso();
        let totalCargos = mensualidades.length;
        mensualidades.map((a) => {
          if (a.is_active == "Si" && frecuencia == a.frecuencia) {
            axios
              .post(
                URL_CARGOS,
                {
                  mensualidad: "Si",
                  fecha,
                  descripcion,
                  importe: a.importe_actual,
                  clientes: a.clientes[0]._id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalCargos = totalCargos - 1;
                if (totalCargos == 0) {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
              });
          } else {
            totalCargos = totalCargos - 1;
          }
        });
      }
    });
  }
  const clear = () => {
    setFecha("");
    setDescripcion("");
    setObservaciones("");
    setFrecuencia("");
  };
function excel() {
  const dataExcelLimpia = comments
    .filter((a) => {
      const pasaEmpresa =
        selectedEmpresaFiltro === "" ||
        (selectedEmpresaFiltro === "ExceptoSistemify"
          ? a.empresa !== "Sistemify"
          : a.empresa === selectedEmpresaFiltro);

      const pasaFrecuencia =
        selectedFrecuencia == 0 || selectedFrecuencia == a.frecuencia;

      const pasaActivo =
        selectedActivo == 0 || selectedActivo == a.is_active;

      const pasaCeros =
        selectedCeros === "No" ||
        (selectedCeros === "Si" && a.importe_actual !== 0);

      const pasaMes =
        !selectedMesAumento ||
        (selectedMesAumento === "SinMes"
          ? !a.mes_aumento
          : a.mes_aumento === selectedMesAumento);

      return pasaEmpresa && pasaFrecuencia && pasaActivo && pasaCeros && pasaMes;
    })
    .map((a) => ({
      Cliente: a.cliente,
      Inicio: a.fecha_inicio,
      MesAumento: a.mes_aumento || "",
      Frecuencia: a.frecuencia,
      Importe: a.importe_actual,
    }));

  var option = {};
  option.fileName = "ListadoMensualidades";

  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: "ListadoMensualidades",
      sheetFilter: ["Cliente", "Inicio", "MesAumento", "Frecuencia", "Importe"],
      sheetHeader: ["Cliente", "Inicio", "Mes Aumento", "Frecuencia", "Importe"],
    },
  ];

  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


  function enviaMail() {
    const data = mensualidades.map((a) => {
     if (
  (
    selectedEmpresaFiltro == 0 ||
    (selectedEmpresaFiltro === "ExceptoSistemify"
      ? a.empresa !== "Sistemify"
      : selectedEmpresaFiltro == a.empresa)
  ) &&
  (selectedFrecuencia == 0 || selectedFrecuencia == a.frecuencia) &&
  (selectedActivo == 0 || selectedActivo == a.is_active) &&
  (selectedCeros === "No" || (selectedCeros === "Si" && a.importe_actual !== 0))
) {
  // ...
}{
        const importe =
          "$" + new Intl.NumberFormat("en-US").format(a.importe_actual);
        totalImporte = totalImporte + a.importe_actual;
        return [
          a.cliente,
          a.fecha_inicio,
          a.frecuencia,
          importe,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    const startY = pdfHeader(doc, "Listado Mensualidades");
    doc.autoTable({
      ...pdfTableStyles(),
      head: [
        [
          "Cliente",
          "Fecha Inicio",
          "Frecuencia",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY,
      foot: [
        [
          "",
          "",
          "Totales",
          "$" + new Intl.NumberFormat("en-US").format(totalImporte),
        ],
      ],
      showFoot: "lastPage",
    });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Resumen Mensualidades",
          email: mailTo,
          fileName: "ResumenMensualidades.pdf",
          att: base64File,
          text: `<!DOCTYPE html>
          <html>
            <head>
              <style>                                
                .img-container {
                                display: block;
                                margin-left: auto;
                                margin-right: auto;
                                height: 90px;
                                width: auto;
                              }
              </style>
            </head>
            <body>
              <img class="img-container" alt="Logo" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" />              
              <h1>${process.env.REACT_APP_NOMBRE_INSTITUCION}</h1>
              <h3>Hola,</h3>
              <h3>Adjunto encontraras el detalle de las mensualidades.</h3>
              <h4>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</h4>
              Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> 
            </body>
          </html>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  }

  function Info(id) {
    setIdInfo(id);
    toggle();
  }

  function jalaInfoEdit(idEdit) {
    const URL_MENSUALIDADES_EDIT = `${process.env.REACT_APP_URL_MENSUALIDADES}/${idEdit}`;
    axios
      .get(URL_MENSUALIDADES_EDIT, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setSelectedCliente(response.data.clientes[0]._id);
        setSelectedEmpresa(response.data.clientes[0].empresa);
        setSelectedClienteName(response.data.clientes[0].nombre_comercial);
        setFechaInicio(response.data.fecha_inicio);
        setDescripcionEdit(response.data.descripcion);
        setObservacionesEdit(response.data.observaciones);
        setMesAumentoEdit(response.data.mes_aumento || "");
        setidCargo(response.data._id);
        toggleEdit();
      })
      .catch((err) => {
      });
  }

  // Cambia solo el renglón editado en la tabla, sin recargar la página
  // (se conservan filtros, orden y la página en la que estabas).
  const actualizaRenglon = (id, cambios) =>
    setComments((prev) => prev.map((r) => (r._id === id ? { ...r, ...cambios } : r)));

  function editCargoMensual(event) {
    event.preventDefault();
    const URL_MENSUALIDADES_EDIT = `${process.env.REACT_APP_URL_MENSUALIDADES}/${idCargo}`;
    axios
      .patch(
        URL_MENSUALIDADES_EDIT,
        {
          fecha_inicio,
          descripcion: descripcionEdit,
          observaciones: observacionesEdit,
          clientes: selectedCliente,
          mes_aumento: mesAumentoEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Mensualidad",
            detalle: `${selectedCliente}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        const cli = clientes.find((c) => c._id === selectedCliente) || {};
        actualizaRenglon(idCargo, {
          fecha_inicio,
          descripcion: descripcionEdit,
          observaciones: observacionesEdit,
          mes_aumento: mesAumentoEdit,
          idCliente: selectedCliente,
          ...(cli._id && {
            cliente: cli.nombre_comercial,
            empresa: cli.empresa,
            contacto: cli.contacto,
          }),
        });
        toggleEdit();
        Swal.fire({ icon: "success", title: "Guardado", timer: 1200, showConfirmButton: false });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  }

  function jalaInfoAumento(idEdit) {
    const URL_MENSUALIDADES_EDIT = `${process.env.REACT_APP_URL_MENSUALIDADES}/${idEdit}`;
    axios
      .get(URL_MENSUALIDADES_EDIT, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setSelectedClienteName(response.data.clientes[0].nombre_comercial);
        setFechaInicio(response.data.fecha_inicio);
        setidCargo(response.data._id);
        setImporteAnterior(response.data.importe_anterior);
        setImporteActual(response.data.importe_actual);
        setUltimoAumento(response.data.ultimo_aumento);
        setFrecuenciaEdit(response.data.frecuencia);
        toggleAumento();
      })
      .catch((err) => {
      });
  }

  function aumentoCargoMensual(event) {
    event.preventDefault();
    const URL_MENSUALIDADES_EDIT = `${process.env.REACT_APP_URL_MENSUALIDADES}/${idCargo}`;
    axios
      .patch(
        URL_MENSUALIDADES_EDIT,
        {
          frecuencia: frecuenciaEdit,
          importe_actual: nuevo_importe,
          importe_anterior: importe_actual,
          ultimo_aumento: fecha_aumento,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        actualizaRenglon(idCargo, {
          frecuencia: frecuenciaEdit,
          importe_actual: Number(nuevo_importe) || 0,
          ultimo_aumento: fecha_aumento,
        });
        toggleAumento();
        Swal.fire({ icon: "success", title: "Importe actualizado", timer: 1200, showConfirmButton: false });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
      });
  }


  const headers = [
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Contacto", field: "contacto", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Fecha Inicio", field: "fecha_inicio", sortable: true },
    { name: "Ultimo Aumento", field: "ultimo_aumento", sortable: true },
    { name: "Mes Aumento", field: "mes_aumento", sortable: true },
    { name: "Frecuencia", field: "frecuencia", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Importe", field: "importe_actual", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  // ── Resumen de tarjetas ────────────────────────────────────────────────────
  const summaryStats = useMemo(() => {
    const fmtImp = (v) => "$" + new Intl.NumberFormat("en-US").format(v);
    const sum    = (arr) => arr.reduce((s, a) => s + (Number(a.importe_actual) || 0), 0);

    const base = comments.filter((a) => {
      if (selectedEmpresaFiltro === "ExceptoSistemify") return a.empresa !== "Sistemify";
      if (selectedEmpresaFiltro) return a.empresa === selectedEmpresaFiltro;
      return true;
    });

    const mensualActivas = base.filter((a) => a.frecuencia === "Mensual" && a.is_active === "Si");
    const anualActivas   = base.filter((a) => a.frecuencia === "Anual"   && a.is_active === "Si");
    const inactivas      = base.filter((a) => a.is_active !== "Si");
    const totalActivas   = base.filter((a) => a.is_active === "Si");

    return {
      mensualActivas: { count: mensualActivas.length, importe: fmtImp(sum(mensualActivas)) },
      anualActivas:   { count: anualActivas.length,   importe: fmtImp(sum(anualActivas))   },
      inactivas:      { count: inactivas.length,       importe: fmtImp(sum(inactivas))      },
      totalActivas:   { count: totalActivas.length,    importe: fmtImp(sum(totalActivas))   },
    };
  }, [comments, selectedEmpresaFiltro]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.contacto.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.frecuencia.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe_actual.toString().includes(search)
          );
    }
    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.is_active.includes(selectedActivo)
      );
    }

    if (selectedCeros) {
  computedComments = computedComments.filter((e) => {
    if (selectedCeros === "Si") {
      return e.importe_actual !== 0; // quitar ceros
    } else {
      return true; // mostrar todo
    }
  });
}

    if (selectedFrecuencia) {
      computedComments = computedComments.filter((e) =>
        e.frecuencia.includes(selectedFrecuencia)
      );
    }

    if (selectedMesAumento) {
      computedComments = computedComments.filter((e) =>
        selectedMesAumento === "SinMes"
          ? !e.mes_aumento
          : e.mes_aumento === selectedMesAumento
      );
    }

  if (selectedEmpresaFiltro === "ExceptoSistemify") {
  computedComments = computedComments.filter(
    (e) => e.empresa !== "Sistemify"
  );
} else if (selectedEmpresaFiltro) {
  computedComments = computedComments.filter(
    (e) => e.empresa === selectedEmpresaFiltro
  );
}
    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field === "mes_aumento") {
      // Enero→Diciembre por calendario; los vacíos van al final
      const idx = (m) => (m ? MESES.indexOf(m) : 99);
      const dir = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => dir * (idx(a.mes_aumento) - idx(b.mes_aumento))
      );
    } else if (
      sorting.field &&
      sorting.field != "importe_actual"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe_actual")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe_actual")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedActivo,
    selectedCeros,
    selectedFrecuencia,
    selectedMesAumento,
    selectedEmpresaFiltro
  ]);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.usuarios_permisos ? (
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcCalendar style={{ marginRight: 8, color: "#8b5cf6" }} />
                Mensualidades
              </h3>
              <p className="page-subtitle">Gestión de cobros recurrentes por cliente</p>
            </div>
            <div className="page-actions">
              <Button size="sm" color="success" onClick={toggleCreate}>
                <IcPlus style={{ marginRight: 6 }} />
                Nueva Mensualidad
              </Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <IcPdf /></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <IcAt /></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <IcExcel /></Button>
              </ButtonGroup>
            </div>
          </div>
          {/* ── Summary cards ─────────────────────────────────────────────── */}
          <div className="row mb-3 mt-1">
            {[
              {
                label: "Mensual Activas",
                count: summaryStats.mensualActivas.count,
                importe: summaryStats.mensualActivas.importe,
                icon: IcSync,
                color: "#8b5cf6", bg: "#f5f3ff",
                desc: "Cobro mensual recurrente",
              },
              {
                label: "Anual Activas",
                count: summaryStats.anualActivas.count,
                importe: summaryStats.anualActivas.importe,
                icon: IcCalendarCheck,
                color: "#3b82f6", bg: "#eff6ff",
                desc: "Cobro anual recurrente",
              },
              {
                label: "Total Activas",
                count: summaryStats.totalActivas.count,
                importe: summaryStats.totalActivas.importe,
                icon: IcCheckCircle,
                color: "#10b981", bg: "#f0fdf4",
                desc: "Mensual + Anual activas",
              },
              {
                label: "Inactivas",
                count: summaryStats.inactivas.count,
                importe: summaryStats.inactivas.importe,
                icon: IcPauseCircle,
                color: "#ef4444", bg: "#fff1f2",
                desc: "Sin cobro activo",
              },
            ].map((card, i) => (
              <div key={i} className="col-6 col-md-3 mb-2">
                <div style={{
                  background: "#fff",
                  borderRadius: 14,
                  padding: "16px 18px",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                  borderTop: `3px solid ${card.color}`,
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  height: "100%",
                }}>
                  <div style={{
                    width: 46, height: 46, borderRadius: 12,
                    background: card.bg, flexShrink: 0,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <card.icon style={{ color: card.color, fontSize: "1.2rem" }} />
                  </div>
                  <div>
                    <div style={{ fontSize: "1.55rem", fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>
                      {card.count}
                    </div>
                    <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#64748b",
                      textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>
                      {card.label}
                    </div>
                    <div style={{ fontSize: "0.72rem", color: card.color, fontWeight: 600, marginTop: 2 }}>
                      {card.importe}
                    </div>
                    <div style={{ fontSize: "0.63rem", color: "#94a3b8", marginTop: 1 }}>
                      {card.desc}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="filter-bar">
            <div>
              <Label>Empresa</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 160 }}
                value={selectedEmpresaFiltro}
                required
                onChange={(e) => {
                  setSelectedEmpresaFiltro(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="ExceptoSistemify">Excepto Sistemify</option>
                <option value="Lynqro">Lynqro</option>
                <option value="Lynqro 2">Lynqro 2</option>
                <option value="Sistemify">Sistemify</option>
              </Input>
            </div>
            <div>
              <Label>Frecuencia</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={selectedFrecuencia}
                required
                onChange={(e) => {
                  setSelectedFrecuencia(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Mensual">Mensual</option>
                <option value="Anual">Anual</option>
              </Input>
            </div>
            <div>
              <Label>Mes Aumento</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={selectedMesAumento}
                onChange={(e) => {
                  setSelectedMesAumento(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {MESES.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
                <option value="SinMes">Sin mes</option>
              </Input>
            </div>
            <div>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 120 }}
                value={selectedActivo}
                required
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </div>
            <div>
              <Label>Quitar 0</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 110 }}
                value={selectedCeros}
                required
                onChange={(e) => {
                  setSelectedCeros(e.target.value);
                }}
              >
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </div>
          </div>
          {/* Encabezados en 2 renglones ("ÚLTIMO / AUMENTO") para que las 10
              columnas quepan en la tarjeta; el scroll horizontal es solo de
              respaldo en pantallas angostas, nunca corta Acciones. */}
          <style>{`
            .mens-tabla .table thead th {
              white-space: normal;
              line-height: 1.25;
              vertical-align: middle;
              padding: 9px 10px !important;
            }
            .mens-tabla .table td {
              vertical-align: middle;
              padding-left: 10px !important;
              padding-right: 10px !important;
            }
            .mens-tabla .nw { white-space: nowrap; }
          `}</style>
          <div className="mens-tabla" style={{ overflowX: "auto" }}>
          <Table size="sm" striped borderless className="table-dark-header">
          <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData
                .map((c) => {
                  tablaImporte = tablaImporte + c.importe_actual
                    return (
                      <tr>
                        <td>{c.cliente}</td>
                        <td>{c.contacto}</td>
                        <td>{c.empresa}</td>
                        <td className="nw">{c.fecha_inicio}</td>
                        <td className="nw">{c.ultimo_aumento}</td>
                        <td className="nw">
                          {c.mes_aumento ? (
                            <span
                              title={c.mes_aumento === MES_ACTUAL ? "Le toca aumento este mes" : undefined}
                              style={{
                                display: "inline-block", padding: "2px 10px", borderRadius: 999,
                                fontSize: "0.74rem", fontWeight: 600,
                                background: (COLOR_MES[c.mes_aumento] || {}).bg || "#eef2f7",
                                color: (COLOR_MES[c.mes_aumento] || {}).txt || "#334155",
                                border: `1px solid ${(COLOR_MES[c.mes_aumento] || {}).borde || "#cbd5e1"}`,
                                // el mes en curso lleva un anillo para que salte a la vista
                                boxShadow: c.mes_aumento === MES_ACTUAL
                                  ? `0 0 0 2px #fff, 0 0 0 3.5px ${(COLOR_MES[c.mes_aumento] || {}).txt}`
                                  : "none",
                              }}
                            >
                              {c.mes_aumento}
                            </span>
                          ) : (
                            <span style={{ color: "#94a3b8", fontSize: "0.74rem" }}>Sin definir</span>
                          )}
                        </td>
                        <td>{c.frecuencia}</td>
                        <td>{c.observaciones}</td>
                        <td align="center" className="nw">
                          {"$" +
                            new Intl.NumberFormat("en-US").format(
                              c.importe_actual
                            )}
                        </td>
                        <td className="nw">
                          <div style={{ display: "flex", gap: 4 }}>
                            <Button color="info" size="sm" title="Editar" onClick={() => jalaInfoEdit(c._id)}>
                              <IcEdit />
                            </Button>
                            <Button color="primary" size="sm" title="Ajustar importe" onClick={() => jalaInfoAumento(c._id)}>
                              <IcDollar />
                            </Button>
                            <Baja idStatus={c._id} is_active={c.is_active} URL_BAJA={process.env.REACT_APP_URL_MENSUALIDADES} />
                          </div>
                        </td>
                      </tr>
                    );
                })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita" align="center">
                  {"$" + new Intl.NumberFormat("en-US").format(tablaImporte)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          </div>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
            </div>
          </div>
        </div>
      ) : undefined}


<Modal size="sm" isOpen={modalGenera} toggle={toggleGenera}>
                <ModalHeader toggle={toggleGenera}>
                  Generar Mensualidades
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    className="col-sm-12"
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                  <Label for="exampleEmail" className="mr-sm-12">
                    Frecuencia
                  </Label>
                  <Input
                    type="select"
                    placeholder="Frecuencia"
                    value={frecuencia}
                    required
                    onChange={(e) => {
                      setFrecuencia(e.target.value);
                    }}
                  >
                    <option value="0">Frecuencia</option>
                    <option value="Mensual">Mensual</option>
                    <option value="Anual">Anual</option>
                  </Input>
                  <Label className="mr-sm-2">Descripcion</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={descripcion}
                    required
                    onChange={(e) => {
                      setDescripcion(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button
                    size="sm"
                    color="success"
                    onClick={generaMensualidades}
                  >
                    Generar
                  </Button>
                </ModalFooter>
              </Modal>

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <IcEdit style={{ marginRight: 8, color: "#8b5cf6" }} />
          Editar Mensualidad
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <IcCalendar />
              <span className="form-section-title">Datos de la Mensualidad</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Cliente</Label>
                    <Input type="select" value={selectedCliente} required onChange={(e) => setSelectedCliente(e.target.value)}>
                      <option value="0">Selecciona un Cliente</option>
                      {clientes.map((c) => <option key={c._id} value={c._id}>{c.nombre_comercial}</option>)}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Fecha Inicio</Label>
                    <Input type="date" value={fecha_inicio} required onChange={(e) => setFechaInicio(e.target.value)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Descripción</Label>
                    <Input type="text" placeholder="Descripción" value={descripcionEdit} required onChange={(e) => setDescripcionEdit(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Observaciones</Label>
                    <Input type="text" placeholder="Observaciones" value={observacionesEdit} required onChange={(e) => setObservacionesEdit(e.target.value)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Mes del siguiente aumento</Label>
                    <Input type="select" value={mesAumentoEdit} onChange={(e) => setMesAumentoEdit(e.target.value)}>
                      <option value="">Sin definir</option>
                      {MESES.map((m) => <option key={m} value={m}>{m}</option>)}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editCargoMensual}>
            <IcSave style={{ marginRight: 6 }} />Guardar Cambios
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalAumento} toggle={toggleAumento}>
        <ModalHeader toggle={toggleAumento}>
          <IcDollar style={{ marginRight: 8, color: "#10b981" }} />
          Ajustar Importe — {selectedClienteName}
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header dark">
              <IcChartLine />
              <span className="form-section-title">Información del Aumento</span>
            </div>
            <div className="form-section-body">
              <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                <div className="stat-chip">
                  <span style={{ color: "#64748b" }}>Importe Anterior:</span>
                  <strong>{"$" + new Intl.NumberFormat("en-US").format(importe_anterior)}</strong>
                </div>
                <div className="stat-chip">
                  <span style={{ color: "#64748b" }}>Importe Actual:</span>
                  <strong style={{ color: "#ef4444" }}>{"$" + new Intl.NumberFormat("en-US").format(importe_actual)}</strong>
                </div>
                <div className="stat-chip">
                  <span style={{ color: "#64748b" }}>Último Aumento:</span>
                  <strong>{ultimo_aumento}</strong>
                </div>
              </div>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Nuevo Importe</Label>
                    <Input type="number" placeholder="0.00" value={nuevo_importe} required onChange={(e) => setNuevoImporte(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Fecha de Aumento</Label>
                    <Input type="date" value={fecha_aumento} required onChange={(e) => setFechaAumento(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Frecuencia</Label>
                    <Input type="select" value={frecuenciaEdit} required onChange={(e) => setFrecuenciaEdit(e.target.value)}>
                      <option value="0">Frecuencia</option>
                      <option value="Quincenal">Quincenal</option>
                      <option value="Mensual">Mensual</option>
                      <option value="Bimestral">Bimestral</option>
                      <option value="Trimestral">Trimestral</option>
                      <option value="Semestral">Semestral</option>
                      <option value="Anual">Anual</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={aumentoCargoMensual}>
            <IcSave style={{ marginRight: 6 }} />Guardar Aumento
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Resumen Mensualidades</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          Estamos generando los cargos, este proceso puede tardar varios
          minutos.
          <br />
          Por favor no cierre ni refresque su navegador.
          <br />
          <div style={{ display: "flex", justifyContent: "center", gap: 10, paddingTop: 16 }}>
            {[0, 1, 2].map((i) => <Spinner key={i} style={{ width: "2rem", height: "2rem", color: "#0f172a" }} />)}
          </div>
        </ModalBody>
      </Modal>
      {/* ── Modal Nueva Mensualidad ──────────────────────────────────── */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcCalendar style={{ marginRight: 8, color: "#8b5cf6" }} />
          Nueva Mensualidad
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <FormGroup>
                <Label>Cliente <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input type="select" value={cClienteMens} onChange={(e) => setCClienteMens(e.target.value)} required
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Selecciona un cliente</option>
                  {clientes.sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((c) => (
                    <option key={c._id} value={c._id}>{c.nombre_comercial} — {c.empresa}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <Label>Frecuencia <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input type="select" value={cFrecuencia} onChange={(e) => setCFrecuencia(e.target.value)} required
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="Mensual">Mensual</option>
                  <option value="Anual">Anual</option>
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <Label>Fecha Inicio <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="date" value={cFechaIni} onChange={(e) => setCFechaIni(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <Label>Importe <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="number" min="0" step="any" value={cImporteMens} onChange={(e) => setCImporteMens(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Descripción</Label>
                <Input bsSize="sm" type="text" value={cDescMens} onChange={(e) => setCDescMens(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Observaciones</Label>
                <Input bsSize="sm" type="text" value={cObsMens} onChange={(e) => setCObsMens(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Mes del siguiente aumento</Label>
                <Input type="select" value={cMesAumento} onChange={(e) => setCMesAumento(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Sin definir</option>
                  {MESES.map((m) => <option key={m} value={m}>{m}</option>)}
                </Input>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveMensualidad}>
            <IcSave style={{ marginRight: 6 }} /> Guardar
          </Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoMensualidades;
